/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST + '/clb'
export const getClbProductAreaTable = params => {
  return axios.post(`${base}/query_product_class`, params)
}
export const getClbProductAreaDetail = params => {
  return axios.get(`${base}/get_product_class_${params.id}`, {params})
}
// export const exportClbProductAreaData = params => {
//   return axios.get(`${base}/query_product_class_${params.id}`, {params})
// }
export const createClbProductAreaData = params => {
  return axios.post(`${base}/create_product_class`, params)
}
export const updateClbProductAreaData = params => {
  return axios.post(`${base}/modify_product_class_${params.id}`, params)
}
export const deleteClbProductAreaData = params => {
  return axios.post(`${base}/delete_product_class_${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/clb-product-area/clb-product-area.api.js